import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { appPreviewObjectTypes } from 'slices/appService.slice';
import type { TAppName } from 'types/app.type';
import type { IPreviewObjectType, TObjectType } from 'types/state.interface';
import { EFieldMappingModes } from '@timeedit/types/lib/enums';
import { Card, Table } from '@timeedit/ui-components/antd';

// CONSTANTS
const PreviewTable = ({
  objectType,
  appName,
}: {
  objectType: TObjectType;
  appName: TAppName;
}) => {
  const previewObjectTypes: IPreviewObjectType[] = useSelector(
    appPreviewObjectTypes(appName, objectType.objectTypeExtId ?? '')
  );

  const fields = previewObjectTypes
    .map((i) =>
      Object.keys(i.fields).reduce(
        (acc, cur) => {
          acc[cur] = i.fields[cur] ?? 'Empty';
          return acc;
        },
        {} as IPreviewObjectType['fields']
      )
    )
    .filter((i) => Object.keys(i).length);

  const { fieldMappingMode } = objectType;

  const columnFields = useMemo(
    () =>
      fieldMappingMode === EFieldMappingModes.RAW
        ? {}
        : fields.reduce(
            (result: any, { appFieldName, fieldLabel }: any) => ({
              ...result,
              [appFieldName]: fieldLabel,
            }),
            { te_extid: 'TE ExtID' }
          ),
    [fieldMappingMode, fields]
  );

  const columns = useMemo(() => {
    if (!fields || !fields[0]) return [];
    // Find the field have max number of keys
    let index = 0;
    let max = 0;
    fields.forEach((i, indexField) => {
      const length = Object.keys(i).length;
      if (length > max) {
        max = length;
        index = indexField;
      }
    });

    return Object.keys(fields[index]).map((key) => ({
      title: columnFields[key] || key,
      dataIndex: key,
      key,
    }));
  }, [fields, columnFields]);

  if (!columns.length) return null;

  return (
    <div className="field-mapping--wrapper" style={{ marginTop: '2rem' }}>
      <Card title="Preview">
        <Table
          pagination={false}
          scroll={{ x: true }}
          dataSource={fields}
          columns={columns}
        />
      </Card>
    </div>
  );
};

export default PreviewTable;
